const LABEL_COPY = {
  anger: "Frustration",
  disgust: "Distrust",
  fear: "Anxiety",
  happy: "Positive",
  neutral: "Neutral",
  sad: "Low mood",
  surprise: "Surprise",
  uncertain: "Uncertain",
};

export function labelCopy(label) {
  return LABEL_COPY[label] || label || "Uncertain";
}

export function formatDuration(ms) {
  if (!ms || ms < 1000) return "under a minute";
  const totalSeconds = Math.round(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (!minutes) return `${seconds}s`;
  return `${minutes}m ${seconds}s`;
}

function averageValence(entries) {
  if (!entries.length) return 0;
  return entries.reduce((sum, entry) => sum + (Number(entry.valence) || 0), 0) / entries.length;
}

// Builds the same kind of post-session emotion summary a business would see
// from the Session Insights product -- derived entirely from the affect
// snapshots already recorded per turn during the live call, no extra capture.
export function buildSessionReport({ affectHistory, timeline, startedAt, endedAt }) {
  const turnCount = affectHistory.length;
  if (!turnCount) return null;

  const counts = {};
  for (const entry of affectHistory) {
    const key = entry.label || "uncertain";
    counts[key] = (counts[key] || 0) + 1;
  }
  const distribution = Object.entries(counts)
    .map(([label, count]) => ({
      label,
      count,
      pct: Math.round((count / turnCount) * 100),
    }))
    .sort((left, right) => right.count - left.count);

  const midpoint = Math.ceil(turnCount / 2);
  const firstHalf = affectHistory.slice(0, midpoint);
  const secondHalf = affectHistory.slice(midpoint);
  const firstValence = averageValence(firstHalf);
  const secondValence = averageValence(secondHalf.length ? secondHalf : firstHalf);
  const arc = secondValence > firstValence + 0.08
    ? "improving"
    : secondValence < firstValence - 0.08
      ? "worsening"
      : "steady";

  const adaptationCount = timeline.filter((item) => (
    typeof item.message === "string" && item.message.startsWith("adaptation sent")
  )).length;

  return {
    durationMs: startedAt ? Math.max(0, (endedAt || Date.now()) - startedAt) : null,
    turnCount,
    distribution,
    dominant: distribution[0] || null,
    opening: affectHistory[0] || null,
    closing: affectHistory[turnCount - 1] || null,
    arc,
    adaptationCount,
  };
}
